<template>
	<div>
		<!-- 图片 -->
		<el-image class="pbg" :src="require('@/static/icon1.jpg')"></el-image>
		<el-image class="pbg" style="background: rgba(0, 0, 0, 0.2);" :src="require('@/static/icon1.png')"></el-image>
		<!-- 登录框 -->
		<!-- <div class="loginform wow animate__fadeIn" data-wow-duration="0.8s"> -->
		<div class="loginform animate__animated animate__fadeIn" data-wow-duration="0.8s">
			<template v-if="selType!=3">
				<p class="tit">Добро пожаловать</p>
				<div class="selType f-ct">
					<div class="t1" @click="selType=0,email='',password=''" :class="selType==0?'a':''">Войти</div>
					<div class="bor"></div>
					<div class="t1" @click="selType=1,email='',password=''" :class="selType==1?'a':''">Зарегистрировать аккаунт</div>
				</div>
			</template>
			<!-- 登录表单 -->
			<div class="loginBox" v-show="selType==0">
				<div class="ipt f-ct">
					<el-image :src="require('@/static/icon2.png')"></el-image>
					<div class="bor"></div>
					<el-input type="text" v-model="email" placeholder="Введите почту"></el-input>
				</div>
				<div class="ipt f-ct">
					<el-image :src="require('@/static/icon3.png')"></el-image>
					<div class="bor"></div>
					<el-input type="password" v-model="password" placeholder="Введите пароль"></el-input>
				</div>
				<div class="tips" @click="wangji">Забыли пароль？</div>
				<div class="btndef anniu" @click="authMemberloginByPassword">Войти</div>
			</div>
			<!-- 注册表单 -->
			<div class="loginBox" v-show="selType==1">
				<div class="ipt ipt1 f-ct">
					<p><span>*</span>Код клиента</p>
					<el-input type="text" v-model="name" placeholder="NM-ваш код"></el-input>
				</div>
				<div class="ipt ipt1 f-ct">
					<p><span>*</span>Email</p>
					<el-input type="text" v-model="email" placeholder="Пожалуйста, введите почтовый ящик"></el-input>
				</div>
				<div class="ipt ipt1 f-ct">
					<p><span>*</span>Проверочный код</p>
					<el-input type="text" v-model="code" placeholder="Проверьте почту"></el-input>
					<div class="codeTxt" style="cursor: pointer;padding-right: 0.1rem;" @click="regCaptcha">{{codetxt}}</div>
				</div>
				<div class="ipt ipt1 f-ct">
					<p><span>*</span>пароль</p>
					<el-input type="password" v-model="password" placeholder="Введите пароль."></el-input>
				</div>
				<div class="ipt ipt1 f-ct">
					<p><span>*</span>Подтвердите пароль</p>
					<el-input type="password" v-model="password1" placeholder="Пожалуйста, введите пароль снова"></el-input>
				</div>
				<div class="btndef anniu" @click="registerByEmail">Зарегистрироваться</div>
			</div>
			<!-- 忘记密码 -->
			<div class="loginBox" v-if="selType==3">
				<div class="has">Номер счета.<span @click="selType=1,email='',password=''">Залогинись немедленно.</span></div>
				<div class="ipt ipt1 f-ct">
					<p><span>*</span>почтовый</p>
					<el-input type="text" v-model="email" placeholder="Пожалуйста, введите почтовый ящик."></el-input>
				</div>
				<div class="ipt ipt1 f-ct">
					<p><span>*</span>CAPTCHA</p>
					<el-input type="text" v-model="code" placeholder="Введите код веридан"></el-input>
					<div class="codeTxt" style="cursor: pointer;" @click="regCaptcha">{{codetxt}}</div>
				</div>
				<div class="ipt ipt1 f-ct">
					<p><span>*</span>пароль</p>
					<el-input type="password" v-model="password" placeholder="Введите пароль."></el-input>
				</div>
				<div class="ipt ipt1 f-ct">
					<p><span>*</span>Подтвердите пароль</p>
					<el-input type="password" v-model="password1" placeholder="Пожалуйста, введите пароль снова"></el-input>
				</div>
				<div class="btndef anniu" @click="authMemberrestPassword">признать</div>
			</div>
		</div>
	</div>
</template>
<script>
import { authMemberloginByPassword,
authMemberInfo,
regCaptcha,
registerByEmail,
authMemberrestPassword
} from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
let that;
let ic;
var nub = 120;
export default {
	components:{},
	data(){
		return {
			selType:0,
			// 表单
			email:'',
			password:'',
			password1:'',
			name:'',
			code:'',
			codetxt:'Отправить',
		}
	},
	mounted() {
		that = this
		// console.log(this.$route.query)
	},
	methods:{
		// 重置密码
		async authMemberrestPassword(){
			if(this.password!=this.password1){
				this.Tips('Пароли, введенные дважды, не совпадают.');
				return
			}
			var data = {
				email:this.email,
				code:this.code,
				password:this.password,
			}
			const res = await authMemberrestPassword(data)
			if(res.code==200){
				this.Tips(res.msg,'success')
				this.selType = 0
			}else{this.Tips(res.msg)}
		},
		// 注册
		async registerByEmail(){
			if(this.password!=this.password1){
				this.Tips('Пароли, введенные дважды, не совпадают.');
				return
			}
			var data = {
				email:this.email,
				code:this.code,
				password:this.password,
				name:this.name,
			}
			const res = await registerByEmail(data)
			if(res.code==200){
				this.Tips('注册成功','success')
				this.selType = 0
			}else{this.Tips(res.msg)}
		},
		// 手机号密码登录
		async authMemberloginByPassword(){
			const res = await authMemberloginByPassword({
				email:this.email,
				password:this.password,
			});
			if(res.code==200){
				this.$store.commit('userMsg/tokenC',res.msg);
				this.getinfo()
			}else{this.Tips(res.msg,'error')}
		},
		// 获取用户信息
		async getinfo(){
			const res = await authMemberInfo({});
			if(res.code==200){
				this.$store.commit('userMsg/userInfoC',res.data.member);
				this.Tips('登录成功','success')
				setTimeout(()=>{
					this.link('/home')
				},1500)
			}else{this.Tips(res.msg,'error')}
		},
		// 验证码
		async regCaptcha(){
			var that = this
			let res = await regCaptcha({email:this.email});
			if(res.code==200){
				this.Tips(res.msg,'success')
				nub = 120
				ic = setInterval(()=>{
					nub--
					that.codetxt = nub+'s'
					if(nub<=0){
						that.codetxt = 'Отправить'
						clearInterval(ic)
					}
				},1000)
			}else{this.Tips(res.msg,'error')}
		},
		wangji(){
			this.selType=3
			this.email = ''
			this.password = ''
			this.password1 = ''
			this.code = ''
		},
	},
	computed:{
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	background: #F5F5F5;
}
</style>
<style lang="scss" scoped>
.page{
	position: relative;
}
.pbg{
	width: 100%;
	position: fixed;
	left: 0;
	top: 0;
	display: block!important;
}
.loginform{
	position: fixed;
	top: 0;
	right: 0;
	width: 778px;
	height: 100%;
	background: #FFFFFF99;
	.tit{
		padding-top: 96px;
		padding-left: 96px;
		font-size: 48px;
		font-weight: bold;
	}
	.selType{
		margin-top: 62px;
		padding-left: 96px;
		.t1{
			font-size: 20px;
			cursor: pointer;
		}
		.a{
			color: #38ABB0;
		}
		.bor{
			width: 2px;
			height: 20px;
			background: #38ABB0;
			margin: 0 20px;
		}
	}
	.loginBox{
		padding-left: 96px;
		padding-right: 96px;
		padding-top: 14px;
		.ipt{
			width: 586px;
			padding: 8px 0;
			// height: 66px;
			background: #fff;
			border-radius: 12px;
			padding-left: 24px;
			margin-top: 32px;
			.el-image{
				width: 24px;
			}
			.bor{
				width: 1px;
				height: 16px;
				background: #DDDDDD;
				margin: 0 20px;
			}
			.el-input{
				width: calc(100% - 105px);
			}
			::v-deep .el-input__inner{
				height: 0.56rem;
				border-radius: 0.08rem;
				border: none;
				padding: 0 0;
				font-size: 0.18rem;
				background: none;
			}
		}
		.ipt1{
			p{
				position: relative;
				font-size: 18px;
				padding-left: 12px;
				text-align: justify;
				text-align-last:justify;
				width: 110px;
				span{
					color: #FF4D5A;
					position: absolute;
					left: 0;
				}
			}
			.el-input{
				width: calc(100% - 265px);
				// background: pink;
				padding-left: 33px;
			}
			.codeTxt{
				text-align: right;
				width: 140px;
				padding-right: 14px;
				font-size: 18px;
				color: #38ABB0;
			}
		}
		.tips{
			text-align: right;
			font-size: 16px;
			color: #38ABB0;
			margin-top: 16px;
			cursor: pointer;
		}
		.anniu{
			margin-top: 0.46rem;
			width: 100%;
			height: 0.66rem;
			line-height: 0.64rem;
			background: #38ABB0;
			border: 1px solid #38ABB0;
			font-size: 20px;
		}
		.has{
			padding-top: 96px;
			// padding-bottom: 12px;
			font-size: 18px;
			span{
				cursor: pointer;
				color: #38ABB0;
				padding-left: 6px;
			}
		}
	}

}
</style>